import {OutBoundsActionType} from "../../actions/outbounds/outboundsAction";
import { v4 as uuidv4 } from 'uuid';

const DefaultOutboundsState = {
    wholesaleList:[],
    total:0,
    carrierListWholesale:[],
    carrierList:[
        {
            dictLabel: "UPS",
            dictValue: "UPS"
        },
        {
            dictLabel: "Canpar",
            dictValue: "Canpar"
        },
        {
            dictLabel: "Canada Post",
            dictValue: "Canada Post"
        },
        {
            dictLabel: "Federal Express",
            dictValue: "Federal Express"
        },
        {
            dictLabel: "Purolator",
            dictValue: "Purolator"
        },
        {
            dictLabel: "UniUni",
            dictValue: "UniUni"
        },
        {
            dictLabel: "PYK",
            dictValue: "PYK"
        },
        {
            dictLabel: "PBX",
            dictValue: "PBX"
        },
        {
            dictLabel: "Rivo",
            dictValue: "Rivo"
        },
        {
            dictLabel: "Skip",
            dictValue: "Skip"
        },
        {
            dictLabel: "DHL",
            dictValue: "DHL"
        },
        {
            dictLabel: "FlashBox",
            dictValue: "FlashBox"
        },
        {
            dictLabel: "Aramex",
            dictValue: "Aramex"
        },
        {
            dictLabel: "DHL SmartePost INTL",
            dictValue: "DHL SmartePost INTL"
        },
        {
            dictLabel: "Fleet Optics",
            dictValue: "Fleet Optics"
        },
        {
            dictLabel: "Intelcom",
            dictValue: "Intelcom"
        },
        {
            dictLabel: "APC",
            dictValue: "APC"
        },
        {
            dictLabel: "Parcel",
            dictValue: "Parcel"
        },
        {
            dictLabel: "ObiBox",
            dictValue: "ObiBox"
        },
        {
            dictLabel: "FlashBird",
            dictValue: "FlashBird"
        },
        {
            dictLabel: "Ulala",
            dictValue: "Ulala"
        },
    ],
    // carrierList:[
    //     {
    //         dictLabel: "ATS",
    //         dictValue: "ATS"
    //     },
    //     {
    //         dictLabel: "Best rate",
    //         dictValue: "BEST RATE"
    //     },
    //     {
    //         dictLabel: "Canada Post",
    //         dictValue: "CANADAPOST"
    //     },
    //     {
    //         dictLabel: "Canada Post Eshipper",
    //         dictValue: "CANADAPOSTESHIPPER"
    //     },
    //     {
    //         dictLabel: "Darwynn Driver",
    //         dictValue: "DARWYNN DRIVER"
    //     },
    //     {
    //         dictLabel: "Federal Express",
    //         dictValue: "Federal Express"
    //     },
    //     {
    //         dictLabel: "Federal Express",
    //         dictValue: "FEDEX"
    //     },
    //     {
    //         dictLabel: "JOEYCO",
    //         dictValue: "JOEYCO"
    //     },
    //     {
    //         dictLabel: "Owner Ship Label",
    //         dictValue: "OWNERSHIPLABEL"
    //     },
    //     {
    //         dictLabel: "Pick up",
    //         dictValue: "PICKUP"
    //     },
    //     {
    //         dictLabel: "Purolator",
    //         dictValue: "PUROLATOR"
    //     },
    //     {
    //         dictLabel: "Seller Directed Shipping",
    //         dictValue: "SDS"
    //     },
    //     {
    //         dictLabel: "UniUni",
    //         dictValue: "UNIUNI"
    //     },
    //     {
    //         dictLabel: "UPS",
    //         dictValue: "UPS"
    //     },
    // ],
    SLAList:[],
    additionalReqList:[],
    carrierSLAList:[],
    platformList:[],
    platformListOwner:[],
    warehouseListOwner:[]
}

export const outboundsReducer = ( state = DefaultOutboundsState, action = {}) =>
{
    switch (action.type) {
        case OutBoundsActionType.OutBounds_SEARCH_LIST:
            return { ...state, wholesaleList: action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], total: action.payload.total?action.payload.total:0}
        case OutBoundsActionType.CARRIER_LIST:
            return { ...state, carrierList: action.payload}
        case OutBoundsActionType.CARRIER_LIST_WHOLESALE:
            return { ...state, carrierListWholesale: action.payload.filter((e)=>{
                return e.dictDesc === 'wholesale'
                }) }

        case OutBoundsActionType.SLA_LIST:
            return { ...state, SLAList: action.payload}
        case OutBoundsActionType.ADDITIONAL_REQ_LIST:
            return { ...state, additionalReqList: action.payload}


        case OutBoundsActionType.CARRIER_SLA_LIST:
            return { ...state, carrierSLAList: action.payload}


        case OutBoundsActionType.PLATFORM_LIST:
            return { ...state, platformList: action.payload}
        case OutBoundsActionType.PLATFORM_LIST_OWNER:
            return { ...state, platformListOwner: action.payload}
        case OutBoundsActionType.WAREHOUSE_LIST_OWNER:
            return { ...state, warehouseListOwner: action.payload}
        default:
            return state;

    }

}